import type { MessageCenterVo, UnreadCountVo } from '@core/types/auto/forum';
import { httpService } from './http';

const BASE = `/api/code-community-forum/gwpub/user/message`;

// 消息中心分页列表：category 缺省为全部；onlyUnread 仅未读；pageNum 从 1 起
export function getMessageCenter(query: {
  category?: number;
  onlyUnread?: boolean;
  pageNum?: number;
  pageSize?: number;
}) {
  return httpService.get<MessageCenterVo>(`${BASE}/center`, { query });
}

// 单条消息置已读
export function setMessageRead(messageId: number) {
  return httpService.post<number>(`${BASE}/read`, { query: { messageId } });
}

// 全部未读置已读
export function setMessageReadAll() {
  return httpService.post<number>(`${BASE}/readAll`);
}

// 未读计数：总数 + 三分类
export function getUnreadCount() {
  return httpService.get<UnreadCountVo>(`${BASE}/unreadCount`);
}
